import Platform from "../../../../../libs/utility/Platform";
import { Theme } from "../../../../components/constants";

export default {
    stepFieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: Platform.isMobileView() ? "100%" : "70%"
    },
    boxInputFieldLabel: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
        width: "50%",
    },
    inputFieldWLabelContainer: {
        display: "flex",
    },
    requiredStarLabel: {
        color: Theme.ERROR_TEXT,
    },
    inputFieldDiv: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    }
}